import { AuthCard, Layout, Loading } from "./components/Layout";
import { Account } from "./pages/Account";
import { CompleteProfile } from "./pages/CompleteProfile";
import { Desktop } from "./pages/Desktop";
import { ForgotPassword } from "./pages/ForgotPassword";
import { SignIn } from "./pages/SignIn";
import { SignUp } from "./pages/SignUp";
import { Link, Redirect, useRouter } from "./router";
import { homeFor, useSession } from "./session";

export function App() {
  const { path } = useRouter();
  const { session } = useSession();

  switch (path.replace(/\/+$/, "") || "/") {
    case "/":
      if (session.status === "loading") return <Loading />;
      if (session.status === "signed-out") return <Redirect to="/signup" />;
      return session.me || session.error ? <Redirect to={homeFor(session.me)} /> : <Loading />;
    case "/signup":
      return session.status === "loading" ? <Loading /> : <SignUp />;
    case "/login":
      return session.status === "loading" ? <Loading /> : <SignIn />;
    case "/forgot-password":
      return <ForgotPassword />;
    case "/complete-profile":
      return <CompleteProfile />;
    case "/account":
      return <Account />;
    case "/desktop":
      return <Desktop />;
    default:
      return (
        <Layout>
          <AuthCard title="הדף לא נמצא">
            <p>
              <Link to="/">לדף הבית של החשבון</Link>
            </p>
          </AuthCard>
        </Layout>
      );
  }
}
